module.exports = __webpack_public_path__ + "static/img/about048.fc3ca2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about048.png
// module id = gpsl
// module chunks = 1